import { IconAnchor } from '@tabler/icons-react'

/**
 * The page footer strip.
 *
 * The mockup carried a trademark attribution line. That is deliberately not
 * reproduced here: asserting who owns a trademark is a legal statement, not a
 * design detail, and it is not mine to invent. Swap in the real line if legal
 * supplies one.
 */
export function AppFooter() {
  return (
    <footer className="lh-footer">
      <span className="lh-footer-anchor" aria-hidden="true">
        <IconAnchor size={13} stroke={1.8} />
      </span>
      <span>Observatory · Lighthouse Data Platform</span>
    </footer>
  )
}
